/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { get as getUser } from 'js/lib/user';

import { Typography2 } from '@coursera/cds-core';

import getFirstName from 'bundles/composable-page-header/utils/getFirstName';
import UserPortrait from 'bundles/page-header/components/UserPortraitV2';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--cds-spacing-150);
    padding-bottom: var(--cds-spacing-100);
  `,
  headerText: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--cds-spacing-50);
  `,
};

type Props = {
  courseraPlusSubscriptionCycle?: string | null;
};
const AccountDropdownHeader = ({ courseraPlusSubscriptionCycle }: Props) => {
  const user = getUser();

  return (
    <div css={styles.header}>
      <UserPortrait user={user} isCourseraPlusLearner={!!courseraPlusSubscriptionCycle} size={32} />
      <div css={styles.headerText}>
        <Typography2 component="p" variant="subtitleLarge">
          {_t('Hi, #{learnerName}', { learnerName: getFirstName(user.fullName) })}
        </Typography2>
        {!!courseraPlusSubscriptionCycle && (
          <Typography2 component="p" variant="bodyTertiary" color="supportText">
            {_t('Coursera Plus (#{cycle})', {
              cycle: courseraPlusSubscriptionCycle === 'MONTHLY' ? _t('Monthly') : _t('Annual'),
            })}
          </Typography2>
        )}
      </div>
    </div>
  );
};

export default AccountDropdownHeader;
